import { RiPencilLine } from "@itandi/itandi-bb-ui";
import type React from "react";
import type { ReactNode } from "react";
import { Button } from "~/components/common/parts/button/Button";
import Styles from "./EditMenuButton.module.scss";

type Props = {
	children: ReactNode;
	onClick: () => void | Promise<void>;
};

export const EditMenuButton: React.FC<Props> = ({
	children,
	onClick
}: Props) => (
	<Button onClick={onClick} size="sm" variant="normal">
		<RiPencilLine className={Styles.Icon} />
		{children}
	</Button>
);
